<template>
    <input :value="value" @input="$emit('input', $event.target.value)" />
</template>

<script>
export default {
    props: ['options', 'value'],
    computed: {
        suggestions() {
            if (this.options)
                return this.options.map(option => ({ value: option }));
        },
    },
    watch: {
        suggestions() { this.updateSuggestions() },
    },
    mounted() {
        let vm = this;
        jQuery(this.$el)
            .autocomplete({
                lookup: this.suggestions,
                autoSelectFirst: true,
                onSelect(suggestion) { vm.$emit('input', suggestion.value); },
            })
            .on('change', function() { vm.$emit('input', this.value); })
            .on('keydown', function(e) { vm.$emit('keydown', e.originalEvent) });
    },
    destroyed() {
        jQuery(this.$el).off().autocomplete('dispose');
    },
    methods: {
        updateSuggestions() {
            jQuery(this.$el).autocomplete('setOptions', { lookup: this.suggestions });
        },
    },
}
</script>
